import React, { Component } from "react";
import styled from "styled-components";
import connect from "../data/redux/connect";
import colors from "../../../styles/colors";

const StyledInput = styled.input`
  display: block;
  padding: 10px;
  border: 1px solid ${colors.border};
  width: 100%;
  font-size: 20px;
  &:focus {
    outline: none;
    border-color: ${colors.accent};
  }
`;

const search = action => e => {
  const { value } = e.target;
  if (value !== "") {
    action(value);
  } else {
    action("");
  }
};

class WordSearch extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { updateDictionary } = this.props.actions;
    return (
      <StyledInput
        type="text"
        placeholder="Zoek een woord"
        onChange={search(updateDictionary)}
      />
    );
  }
}

export default connect(WordSearch);



// WEBPACK FOOTER //
// ./src/apps/lexikon/components/WordSearch.js